// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import useWindowSize from './hooks/useWindowSize';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

const RootComponent = () => {
  const { width } = useWindowSize(); // Track window size

  let screenClass = '';
  if (width < 600) {
    screenClass = 'mobile';
  } else if (width >= 600 && width < 1024) {
    screenClass = 'tablet';
  } else {
    screenClass = 'desktop';
  }

  return (
    <div className={`root-container ${screenClass}`}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

reportWebVitals();
